<template v-slot:tabItem="{ current }">
  <v-container fluid class="mb-4">
    <v-row justify="center">
      <v-col>
        <v-card>
          <v-toolbar
              color="primary"
              :dark="$vuetify.theme.dark"
              flat
              dense
              tabs>
            <v-row>
              <v-col cols="12" class="text-left">
                <v-toolbar-title>
                  {{ $t('Список шаблонов') }}
                </v-toolbar-title>
              </v-col>
            </v-row>
          </v-toolbar>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <general-error v-if="!!generalError" />
        <v-row>
          <v-col>
            <paginated-data-table
                v-if="getLotsTemplates"
                ref="paginatedTable"
                :headers="headers1"
                :items="templates"
                :loading="isLoading"
                item-key="lotTemplateId"
                :total-count="totalCount"
                :items-per-page="itemsPerPage"
                single-expand
                show-expand
                :request-method="getLotsTemplates">
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.lotType="{ item }">
                {{ $t(LOT_TYPE_ENUM[item.lotType]) }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.createDate="{ item }">
                {{ item.createDate
                  ? $moment(item.createDate).format('DD.MM.YYYY HH:mm')
                  : null }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.lotDescription="{ item }">
                <route-link-with-tip
                    :text="item.lotDescription"
                    :tip="$t('Просмотр шаблона')"
                    :to="{ path: `${urlRootPath}/template/${item.lotType}/${item.lotTemplateId}` }" />
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">

                  <v-divider />
                  <v-row class="text-left my-1">
                    <lot-template-actions
                        :key="item.lotTemplateId"
                        :lot-template-id="item.lotTemplateId"
                        :lot-type="item.lotType"
                        :edited="$refs.paginatedTable.getDataFromServer" />
                  </v-row>
                </td>
              </template>

            </paginated-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import LotTemplateActions from '@/components/pages/shared/LotTemplate/LotTemplateActions.vue'
  import PaginatedDataTable from '@/components/reused/ui/PaginatedDataTable.vue'
  import RouteLinkWithTip from '@/components/reused/ui/RouteLinkWithTip.vue'
  import { LOT_TYPE_ENUM, TRADE_RESULT_TYPE_ENUM, SET_UNSET_ENUM } from '@/constants/enums'
  import { LOT_STATUSES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { LOT_TEMPLATE_MANAGEMENT } from '@/constants/store.js'
  export default {
    components: {
      GeneralError,
      PaginatedDataTable,
      LotTemplateActions,
      RouteLinkWithTip
    },

    data () {
      return {
        isLoading: false,
        LOT_TYPE_ENUM,
        LOT_STATUSES,
        TRADE_RESULT_TYPE_ENUM,
        SET_UNSET_ENUM,
        itemsPerPage: 10,
        params: {}
      }
    },
    computed: {
      ...mapState(LOT_TEMPLATE_MANAGEMENT.NAMESPACE, {
        lotTemplates: state => (state[LOT_TEMPLATE_MANAGEMENT.STATE.TEMPLATES_LIST] || {})
      }),
      headers1 () {
        return [
          { text: this.$t('№ шаблона'), align: 'start', sortable: true, value: 'lotTemplateNumber' },
          { text: this.$t('Дата и время создания шаблона'), align: 'start', sortable: true, value: 'createDate' },
          { text: this.$t('Торговая процедура'), align: 'start', sortable: true, value: 'lotDescription' },
          { text: this.$t('Тип торговой процедуры'), align: 'start', sortable: true, value: 'lotType', width: '40%' },
          { text: '', value: 'data-table-expand' }
        ]
      },
      totalCount () {
        return this.lotTemplates.totalCount || 0
      },
      templates () {
        return this.lotTemplates.items || []
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOT_TEMPLATE_MANAGEMENT.NAMESPACE, {
        getLotsTemplatesAction: LOT_TEMPLATE_MANAGEMENT.ACTIONS.GET_LOT_TEMPLATES,
        clearLotsListAction: LOT_TEMPLATE_MANAGEMENT.ACTIONS.CLEAR_LOT_TEMPLATES
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearLotsListAction(this.lotStatus)
          ])
      },
      getLotsTemplates: async function (params) {
        try {
          this.isLoading = true
          await this.getLotsTemplatesAction({
            params: {
              ...this.params,
              ...params
            }
          }
          )
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
